import React, { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  uploadProductImage,
  deleteProductImage,
  setMainProductImage,
} from '../features/products/productsSlice';
import ConfirmModal from './ConfirmModal';
import './ProductImageGallery.css';

/**
 * ProductImageGallery — управление несколькими фото товара.
 *
 * Props:
 *   productId — ID товара
 *   images    — массив { id, image, is_main, order }
 */
export default function ProductImageGallery({ productId, images = [] }) {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [confirmId, setConfirmId] = useState(null);

  const handleUpload = useCallback(
    (e) => {
      const files = Array.from(e.target.files || []);
      files.forEach((file) => {
        dispatch(uploadProductImage({ productId, file, isMain: images.length === 0 }));
      });
      e.target.value = '';
    },
    [dispatch, productId, images.length]
  );

  const handleDelete = useCallback((imageId) => {
    setConfirmId(imageId);
  }, []);

  const confirmDelete = useCallback(() => {
    dispatch(deleteProductImage({ productId, imageId: confirmId }));
    setConfirmId(null);
  }, [dispatch, productId, confirmId]);

  const handleSetMain = useCallback(
    (imageId) => {
      dispatch(setMainProductImage({ productId, imageId }));
    },
    [dispatch, productId]
  );

  return (
    <div className="pig-container">
      <ConfirmModal
        open={confirmId !== null}
        title="Удалить фото?"
        message="Это действие нельзя отменить."
        confirmLabel="Удалить"
        danger
        onConfirm={confirmDelete}
        onCancel={() => setConfirmId(null)}
      />
      <div className="pig-grid">
        {images.map((img) => (
          <div key={img.id} className={`pig-card ${img.is_main ? 'pig-card--main' : ''}`}>
            <img src={img.image} alt="" className="pig-img" />
            {img.is_main && <div className="pig-badge">Главное</div>}
            <div className="pig-actions">
              {!img.is_main && (
                <button
                  type="button"
                  className="pig-btn pig-btn--main"
                  onClick={() => handleSetMain(img.id)}
                  title="Сделать главным"
                >
                  ★
                </button>
              )}
              <button
                type="button"
                className="pig-btn pig-btn--delete"
                onClick={() => handleDelete(img.id)}
                title="Удалить"
              >
                ✕
              </button>
            </div>
          </div>
        ))}

        {/* Upload card */}
        <button
          type="button"
          className="pig-upload-card"
          onClick={() => fileInputRef.current?.click()}
          title="Добавить фото"
        >
          <span className="pig-upload-icon">+</span>
          <span className="pig-upload-label">Добавить фото</span>
        </button>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        style={{ display: 'none' }}
        onChange={handleUpload}
      />

      {images.length === 0 && (
        <p className="pig-empty">Нет фотографий. Нажмите «+» чтобы загрузить.</p>
      )}
    </div>
  );
}
